import { cva } from 'class-variance-authority';

export const sliderBarRootClasses = cva([
  'relative flex w-full touch-none items-center select-none',
  'data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50'
]);

export const sliderBarTrackClasses = cva([
  'bg-charcoal-50 relative h-1 w-full grow overflow-hidden rounded-full'
]);

export const sliderBarRangeClasses = cva(['bg-charcoal-500 absolute h-full']);

export const sliderBarThumbClasses = cva([
  'bg-white-50 border-charcoal-500 block h-4 w-4 border-solid rounded-full border-1 shadow-sm transition',
  'focus-visible:outline-info-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
  'disabled:pointer-events-none'
]);
